//#region Typedefs

/**
 * @typedef {Object} GTMEcommerceItemData
 * @property {string} [item_id]
 * @property {string} [item_name]
 * @property {number} price
 * @property {number} quantity
 * @property {string} [affiliation]
 * @property {string} [coupon]
 * @property {number} [discount]
 * @property {number} [index]
 * @property {string} [item_brand]
 * @property {string} [item_category]
 * @property {string} [item_category2]
 * @property {string} [item_category3]
 * @property {string} [item_category4]
 * @property {string} [item_category5]
 * @property {string} [item_list_id]
 * @property {string} [item_list_name]
 * @property {string} [item_variant]
 */

/**
 * @typedef {Object} GTMEcommerceData
 * @property {"USD"} currency
 * @property {number} value
 * @property {GTMEcommerceItemData[]} items
 * @property {string} [coupon]
 */

/**
 * @typedef {Object} CartAttributeViewModel
 * @property {string} code
 * @property {string} name
 * @property {string} value
 */

/**
 * @typedef {Object} CartRestrictionViewModel
 * @property {string|null|undefined} endDate
 * @property {number} maxOrderableQuantity
 * @property {string} restrictionType
 * @property {string} message
 * @property {string|null|undefined} startDate
 */

/**
 * @typedef {Object} CartPartViewModel
 * @property {string} productName
 * @property {CartAttributeViewModel[]} attributes
 * @property {boolean} autoShipExists
 * @property {number|null|undefined} cartAutoShipFrequency
 * @property {number} depth
 * @property {string} description
 * @property {number} height
 * @property {string} image
 * @property {number} basePrice
 * @property {number} salePrice
 * @property {boolean} orderable
 * @property {string} partNo
 * @property {number} partQuantity
 * @property {string} partType
 * @property {CartRestrictionViewModel[]} restriction
 * @property {string} unitOfMeasure
 * @property {number} weightInPounds
 * @property {number} width
 * @property {number} yourPrice
 * @property {string} productGuid
 * @property {boolean} isUserFavorite
 * @property {string} itemCategory
 * @property {object} error
 * @property {string} sLPLabel
 * @property {boolean} blocksOrdering
 * @property {number} maxQuantity
 * @property {string} classDesignation
 */

/**
 * @typedef {Object} ShoppingCartViewModel
 * @property {boolean} isCart
 * @property {number} cartCount
 * @property {string|null} createDate
 * @property {string} createdBy
 * @property {string} customerId
 * @property {string} customerName
 * @property {string} listId
 * @property {string} listName
 * @property {string} listType
 * @property {string} modifiedBy
 * @property {string|null} modifyDate
 * @property {number} basePriceSubtotal
 * @property {number} salesPriceSubtotal
 * @property {number} orderSLPTotal
 * @property {number} minOrderThreshold
 * @property {CartPartViewModel[]} parts
 * @property {CartPartViewModel[]} savedParts
 * @property {string} shippingAddressId
 * @property {string} salesChannel
 * @property {string} sLPLabel
 * @property {string} gAObject
 */

/**
 * @typedef {Object} CartAjaxModel
 * @property {ShoppingCartViewModel} cart
 * @property {string} updatedPartial
 */

/**
 * @callback CartAjaxModelResponse
 * @param {CartAjaxModel} response
 * @returns {void}
 */

//#endregion

var site = site || {};
site.Cart = (function () {
    const orderSubmitBtnText = 'Place Your Order';
    const checkoutBtnText = 'Proceed to Checkout';
    let loadingSpinner = `<i class="fa fa-spinner fa-1x fa-spin payment-spinner"></i>`;
    let complianceWarningIcon = '<i class="prop-65-alert fas fa-exclamation-triangle"></i>';
    let freeShippingMin;
    var timeoutID = undefined;


    // Private/internal state object used to track the items in the cart.
    const cartState = {
        /** @type {ShoppingCartViewModel|null} */
        shoppingCartViewModel: null,
    };

    //If the user is not on the cart page; there is no need to set this to the true min order threshhold as they cannot view it anyway.
    if ($('#shoppingCart').is(':visible') || $('.checkout-container').is(':visible')) {
        freeShippingMin = $('.slpSubtotal').data().minOrderThreshold;
    }
    else {
        freeShippingMin = '150';
    }
    var needShippingData = function (state) {
        site.Cart.requestShippingRates = state;
    }

    /**
     * Enables or disables a button.
     * @param {JQuery<HTMLElement>} btn 
     * @param {string} btnText 
     * @param {boolean} state True to disable the button, false to enable.
     */
    var enableDisableButton = function (btn, btnText, state) {
        if (btn === null || btn === undefined) {
            return;
        }

        btn.text('')
            .append(btnText)
            .prop('disabled', state);

        state ? btn.addClass('disabled') : btn.removeClass('disabled');
    }

    var showHideBtn = function (btn, state) {
        if (typeof btn != 'undefined') {
            state === "show" ? btn.addClass('disabled') : btn.removeClass('disabled')
        }
    }

    var getAutoShipFrequency = function (cardHeader) {
        console.log("getting autoship frequency")
        console.log(cardHeader)
    }

    var refreshCartPartsQuoteCartData = function (quoteReturnData) {
        refreshTotalsWithCartAndQuote(quoteReturnData);
    }

    var refreshTotalsWithCartData = function (cart) {
        let taxTotal = 0;
        let cartItemsCountContainer = $(".total-items");
        let freeShippingDiffAmountContainer = $(".shipping-difference");
        let cartSubtotalContainer = $('.cart-subtotal');
        let itemsSubtotalContainer = $('.items-subtotal');
        let orderTotalContainer = $('.order-total');
        let slpSubtotal = $('.slpSubtotal');
        if ($('.checkout').is(':visible')) {
            let taxTotal = $('.tax-total').text();
            taxTotal = parseFloat(taxTotal);
        }
        let totalFromCart = cart.salesPriceSubtotal > 0 ? cart.salesPriceSubtotal.toFixed(2) : cart.basePriceSubtotal.toFixed(2);
        let totalSLP = cart.basePriceSubtotal.toFixed(2);
        let shippingTotal = "0.00";
        let orderTotal = (parseFloat(totalFromCart) + parseFloat(shippingTotal) + parseFloat(taxTotal));
        let freeShippingDiffAmount = freeShippingMin - totalSLP;
        let itemTotalText = cart.cartCount > 1 ? cart.cartCount + " items" : cart.cartCount + " item";
        cartItemsCountContainer.text(itemTotalText);
        cartSubtotalContainer.text(totalFromCart);
        itemsSubtotalContainer.text(totalFromCart);
        orderTotalContainer.text(orderTotal.toFixed(2));
        for (let lineItem of cart.parts) {
            let lineItemTotal = lineItem.salePrice > 0 ? lineItem.salePrice * lineItem.partQuantity : lineItem.basePrice * lineItem.partQuantity;
            $("#" + lineItem.partNo + "-item-total").text(lineItemTotal.toFixed(2));
        }
        freeShippingDiffAmountContainer.text(freeShippingDiffAmount.toFixed(2));
        slpSubtotal.data('slp-subtotal', cart.orderSLPTotal.toFixed(2))
        slpSubtotal.text(cart.slpLabel + ' Subtotal: $' + cart.orderSLPTotal.toFixed(2));
        site.Cart.shippingProgressBar();

    }

    var refreshTotalsWithCartAndQuote = function (quoteReturnData) {
        var cart = quoteReturnData.cart;
        let taxTotal = 0;
        let shippingTotal = 0;
        let cartItemsCountContainer = $(".total-items");
        let freeShippingDiffAmountContainer = $(".shipping-difference");
        let cartSubtotalContainer = $('.cart-subtotal');
        let itemsSubtotalContainer = $('.items-subtotal');
        let orderTotalContainer = $('.order-total');
        let slpSubtotal = $('.slpSubtotal');
        let $freeShippingMessageContainer = $("#shippingFreeShipping");

        if (site.Utilities.onCheckout()) {
            taxTotal = quoteReturnData.quoteOrderResponse.orderTotalTax;
            taxTotal = parseFloat(taxTotal);
        }
        else {
            shippingTotal = "0.00"
        }

        let totalFromCart = cart?.salesPriceSubtotal > 0 ? cart?.salesPriceSubtotal.toFixed(2) : cart?.basePriceSubtotal.toFixed(2);
        let totalSLP = cart.basePriceSubtotal.toFixed(2);
        let orderTotal = (parseFloat(totalFromCart) + parseFloat(shippingTotal) + parseFloat(taxTotal));
        let freeShippingDiffAmount = freeShippingMin - totalSLP;
        let itemTotalText = cart.cartCount > 1 ? cart.cartCount + " items" : cart.cartCount + " item";
        cartItemsCountContainer.text(itemTotalText);
        cartSubtotalContainer.text(totalFromCart);
        itemsSubtotalContainer.text(totalFromCart);
        orderTotalContainer.text(orderTotal.toFixed(2));
        for (let lineItem of cart.parts) {
            let lineItemTotal = lineItem.salePrice > 0 ? lineItem.salePrice * lineItem.partQuantity : lineItem.basePrice * lineItem.partQuantity;
            $("#" + lineItem.partNo + "-item-total").text(lineItemTotal.toFixed(2));
        }
        freeShippingDiffAmountContainer.text(freeShippingDiffAmount.toFixed(2));
        slpSubtotal.data('slp-subtotal', cart.orderSLPTotal.toFixed(2))
        slpSubtotal.text(cart.slpLabel + ' Subtotal: $' + cart.orderSLPTotal.toFixed(2));
        if (site.Utilities.onCheckout()) {
            quoteReturnData.cart["orderTotalTax"] = quoteReturnData.cart.orderTotalTax;
            quoteReturnData.cart["orderTotalFees"] = quoteReturnData.cart.orderTotalFees;
            setOrderSummaryValuesAfterDataReturns(quoteReturnData.quoteOrderResponse);
        }

        if (freeShippingDiffAmount <= 0) {
            $freeShippingMessageContainer.removeClass("d-lg-block").addClass("d-none");
        } else {
            $freeShippingMessageContainer.removeClass("d-none").addClass("d-lg-block");
        }
        
        site.Cart.shippingProgressBar()
    }

    var refreshCartCount = function () {
        let name = "CartCount=";
        let cookies = document.cookie.split(';');
        let cookieFound = false;
        let cartCount = 0;
        for (var i = 0; i < cookies.length; i++) {
            var c = cookies[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1, c.length);
            }
            if (c.indexOf(name) == 0) {
                cookieFound = true;
                cartCount = c.substring(name.length, c.length);
                $(".cart-badge").html(cartCount);
            }
        }
        if (!cookieFound || cartCount <= 0) {
            $(".cart-badge").hide();
        }
        else {
            $(".cart-badge").show();
        }
    }

    // Formatting of the zip code on add/edit shipping address modal form
    $('#zip-code').on('keyup', function () {
        let zip = this.value;
        zip = zip.replace(/[^\d\-]/g, ''); // Remove all non-numeric and non-dash characters
        if (zip.length >= 6 && zip[5] != '-') {
            zip = zip.substring(0, 5) + '-' + zip.substring(5);
        }
        this.value = zip;
    });

    var refreshSaveForLaterView = function (itemCategory) {
        switch (itemCategory) {
            case 'Product':
                $('#saveForLaterProducts').click();
                break;
            case 'Literature':
                $('#saveForLaterLiterature').click();
                break;
            case 'Merchandise':
                $('#saveForLaterMerchandise').click();
                break;
        }
    }

    var shippingProgressBar = function () {
        let slpSubTotal = $('.sum-1 .slpSubtotal');
        if (typeof slpSubTotal === 'undefined' || slpSubTotal.length === 0) {
            return;
        }
        // Progress bar calculations
        let newProgress = Math.floor(slpSubTotal.data().slpSubtotal);
        var progressBar = $('.js-progress-bar');
        if (newProgress >= freeShippingMin) {
            // If $100 has been spent, remove progress bar animation, set shipping cost to $0, change to success message, and remove progress message
            progressBar.css('background-color', '#00573D').removeClass('progress-bar progress-bar-striped progress-bar-animated');
            $('.free-shipping-heading').html('<i class="fa fa-bullhorn primary-color"></i> <strong class="primary-color">You Unlocked Free Shipping!</strong>');
            $('.progress-amounts').addClass('primary-color');
            progressBar.css('background-color', '#00573D');
            $('.free-shipping-msg').hide();
            $('.slpSubtotal').hide();
            $('.js-continue-shopping').hide();
        } else {
            progressBar.css('background-color', '#C3882C');
            progressBar.addClass('progress-bar progress-bar-striped progress-bar-animated');
            $('.progress-amounts').removeClass('primary-color');
            $('.free-shipping-heading').html('<i class="fas fa-box-usd"></i> <strong>Unlock Free Shipping!</strong>');
            $('.free-shipping-msg').show();
            $('.slpSubtotal').show();
            $('.js-continue-shopping').show();
        };
        progressBar.attr('aria-valuenow', (newProgress / freeShippingMin * 100)).css('width', (newProgress / freeShippingMin * 100) + '%');
    }

    var getShippingRates = function (shipVia = null, selectedInput = null) {
        if (site.Cart.requestShippingRates) {
            if (shipVia == null) {
                if (selectedInput == null) {
                    selectedInput = $('input[name="shippingMethod"]:checked');
                }
                if (selectedInput.length === 0) {
                    shipVia = null
                } else {
                    shipVia = selectedInput.data().shipVia;
                }
            }
            //get the payment method.
            let paymentObject = $("input[name='paymentMethod']").filter(':checked');
            let isCOD = false;
            if (paymentObject?.data()?.paymentTerm == "COD") {
                isCOD = true;
            }
            //Bottom button to proceed
            $('#continue-to-payment-button').addClass('disabled').text('').append(site.Cart.loadingSpinner);

            //Top nav pill 
            $('#continue-to-payment-button').prop('disabled', true)
            $('.toggle-shipping-list.ms-4').hide();
            $('.toggle-shipping-list-spinner').removeClass('d-none');
            $('.shipping-method-options').html('').addClass('d-none');
            $('.toggle-shipping-list-error').addClass('d-none');
            //Spin the tax, spin shipping, spin order total ONLY
            //if ($('.shipping-details').is(':visible')) {
            //orderSummarySpinnersSpin();

            //}
            return new Promise(function (fulfilled, rejected) {

                $.ajax({
                    method: 'POST',
                    url: '/cart/GetShippingRates',
                    data: { selectedShippingMethod: shipVia, isCOD: isCOD },
                    dataType: 'json',
                }).done(function (data) {
                    if (data && data.renderedPartial != null) {
                        $('.toggle-shipping-list-spinner').addClass('d-none')
                        $(".shipping-method-options").append(data.renderedPartial).removeClass('d-none')
                        $('#reloadShippingIndicator svg').addClass('d-none');
                        
                        $('.shipping-form-check.form-check.active').removeClass('active');
                        $(`.shipping-form-check [for="${shipVia}"]`).parent().addClass('active');

                        $('#continue-to-payment-button').removeClass('disabled').prop('disabled', false).html('Continue to Payment <i class="fal fa-chevron-right"></i>')
                        fulfilled(data)
                    }
                    else {
                        $('.toggle-shipping-list-spinner').addClass('d-none');
                        $('.toggle-shipping-list-error').removeClass('d-none');
                        $('.continue-to-payment').prop('disabled', true).addClass('disabled');
                        orderSummarySpinnersRemove();
                        rejected(data);
                    }
                }).fail(function () {
                    orderSummarySpinnersRemove();
                    $('.toggle-shipping-list-error').removeClass('d-none');
                    $('.continue-to-payment').prop('disabled', true).addClass('disabled');
                    rejected(data);
                    console.log("Error retrieving updated shipping data from cart.");
                });
            })
        }
    }

    /**
     * Sets the initial shopping cart view model. Should only ever be called
     * once at page load.
     * @param {ShoppingCartViewModel} shoppingCartViewModel
     * @returns {void}
     */
    var initializeShoppingCartViewModel = function (shoppingCartViewModel) {
        if (cartState.shoppingCartViewModel !== null) {
            return;
        }

        cartState.shoppingCartViewModel = shoppingCartViewModel;
    }

    var checkQuickOrderCartBtn = function () {
        var partInput = $('#product-search-input').val();
        var partNo = $('#product-search-input').attr('data-part-number');
        var description = $('#product-search-input').attr('data-part-description');
        if (!partInput || partInput == '' || partInput !== partNo + " " + description) {
            return;
        }

        var inCart = $('#product-search-input').attr('data-part-incart');
        var qtyInput = $('#product-quantity-input').val();
        qtyInput = qtyInput == "" ? 0 : $('#product-quantity-input').val();
        var qtyHasValue = !qtyInput === false && qtyInput != '';
        var maxQty = parseInt($('#product-quantity-input').attr('max'));
        var maxQtyMessage = $('#product-search-input').attr('data-part-maxquantity-message');
        //If the user entered a value
        if (qtyHasValue) {
            var totalQty = inCart != "" ? parseInt(qtyInput) + parseInt(inCart) : parseInt(qtyInput);
            var qtyIsOverMax = qtyHasValue == true && parseInt(totalQty) > parseInt(maxQty);
            //Did the user enter a quantity 
            if (qtyIsOverMax == true) {
                $('.js-quickOrder-add-cart').prop('disabled', true);
                $('#search-alert-msg').html("<i class='fas fa-solid ms-1 mt-0 me-1 fa-exclamation-triangle warningMsg lh-lg'></i><p class='mb-0' style='color: #bd5531;'>" + maxQtyMessage + "</p>");
                $('#search-alert-msg').removeClass('d-none');
                return;
            } else {
                $('.js-quickOrder-add-cart').prop('disabled', false);
            }
        }

        var notice = $('#product-search-input').attr('data-part-notice');
        var restriction = $('#product-search-input').attr('data-part-restriction-message');
        var blocked = $('#product-search-input').attr('data-part-blocking').toLowerCase() === 'true' ? true : false;
        if (blocked == true) {
            $('.js-quickOrder-add-cart').prop('disabled', true);
            $('#search-alert-msg').html("<i class='fas fa-solid ms-1 mt-0 me-1 fa-exclamation-triangle warningMsg lh-lg'></i><p class='mb-0' style='color: #bd5531;'>" + restriction + "</p>");
            $('#search-alert-msg').removeClass('d-none');
            return;
        } else if (restriction != "" || restriction != undefined) {
            $('#search-alert-msg').html("<i class='fas m-1 fa-solid fa-info-circle warningMsg lh-lg'></i><p class='mb-0'>" + restriction + "</p>");
            $('#search-alert-msg').removeClass('d-none');
        }

        if (qtyHasValue === false || qtyInput == 0) {
            $('.js-quickOrder-add-cart').prop('disabled', true);
            return;
        }

        $('#product-quantity-input').one('keypress', AddQuickOrderOnEnter);

        if (restriction && restriction != notice) {
            if (blocked) {
                $('#search-alert-msg').html("<i class='fas fa-solid mt-0 fa-exclamation-triangle warningMsg lh-lg'></i><p class='mb-0' style='color: #bd5531;'>" + restriction + "</p>");
            } else {
                $('#search-alert-msg').html("<i class='fas m-1 mt-0 fa-solid fa-info-circle warningMsg lh-lg'></i><p class='mb-0'>" + restriction + "</p>");
            }
        }
        else {
            $('#search-alert-msg').text("");
            $('#search-alert-msg').addClass('d-none');
        }
    }

    function AddQuickOrderOnEnter(key) {
        if (key.which == 13) {
            const liveToast = document.getElementById('cartToast');
            const toast = new bootstrap.Toast(liveToast, {
                delay: 3000
            });
            toast.show();
            $('.js-quickOrder-add-cart').click();
        }
    }

    var calculateShippingCost = function () {
        var selectedShippingCost = $('.shipping-address-input').length > 0 && $('.shipping-address-input').filter(':checked').data().shippingCost != null && $('.shipping-address-input').filter(':checked').data().shippingCost > 0 && parseInt($('.shipping-address-input').filter(':checked').data().shippingCost) >= 0 ? $('.shipping-address-input').filter(':checked').data().shippingCost : 0;
        //Get the value of cart subtotal
        if (selectedShippingCost == null) {
            selectedShippingCost = $('input[name="shippingMethod"]:checked').data().shippingCost
        }
        var cartSubtotal = parseFloat($('.cart-subtotal:first').text().toString());

        var orderTotal = cartSubtotal + Number(selectedShippingCost);
        //Show two decimal places and update the order total
        if ($('.checkout').is(':visible')) {
            if ($('.slpSubtotal').data().slpSubtotal >= $('.slpSubtotal').data().minOrderThreshold && $('.shipping-address-input').filter(':checked').data().shippingCost == 0) {
                $('.shipping-total').text(parseFloat(0).toFixed(2));
            }
            else {
                $('.shipping-total').text(parseFloat(selectedShippingCost).toFixed(2));
            }
        }
        else if ($('.slpSubtotal').data().slpSubtotal >= $('.slpSubtotal').data().minOrderThreshold) {
            $('.shipping-total').text(parseFloat(0).toFixed(2));
        }
        else {
            $('.shipping-total').text(parseFloat(selectedShippingCost).toFixed(2));
        }
        $('.order-total').text(Number(orderTotal).toFixed(2));
    }

    var checkForEmptyCart = function (data) {
        if (data.cart.cartCount <= 0 && $('.review-order-details').is(':visible')) {
            window.location.href = "/cart";
            return;
        }
    }

    var subtotalActivateSpinners = function (spin) {
        if (spin) {

            $('.items-subtotal').text('');
            $('.items-subtotal').append(site.Cart.loadingSpinner);
            $('.items-subtotal').find('.payment-spinner').addClass('primary-color');

            $('.cart-subtotal').text('')
            $('.cart-subtotal').append(site.Cart.loadingSpinner);
            $('.cart-subtotal').find('.payment-spinner').addClass('primary-color');
        }
        else {
            $('.items-subtotal').find('.payment-spinner').remove();
            $('.cart-subtotal').find('.payment-spinner').remove();
        }
    }

    var orderSummarySpinnersSpin = function () {
        if ($('.js-cod-summary').is(":visible")) {
            $('.cod-total').text('')
            $('.cod-total').append(site.Cart.loadingSpinner);
            $('.cod-total').find('.payment-spinner').addClass('primary-color');
        }

        $('.tax-total').text('');
        $('.tax-total').append(site.Cart.loadingSpinner);
        $('.tax-total').find('.payment-spinner').addClass('primary-color');

        $('.shipping-total').text('')
        $('.shipping-total').append(site.Cart.loadingSpinner);
        $('.shipping-total').find('.payment-spinner').addClass('primary-color');

        $('.order-total').text('');
        $('.order-total').append(site.Cart.loadingSpinner);
        $('.order-total').find('.payment-spinner').addClass('primary-color');
    }


    var orderSummarySpinnersRemove = function () {
        if ($('.js-cod-summary').is(":visible")) {
            $('.cod-total').find('.payment-spinner').remove();
        }
        $('.tax-total').find('.payment-spinner').remove();
        $('.order-total').find('.payment-spinner').remove();
        $('.shipping-total').find('.payment-spinner').remove();
    }


    //Processes the Summary values utilizing the Quote passed in
    var setOrderSummaryValuesAfterDataReturns = function (data) {
        var shippingTotal = 0
        var formatting_options = {
            minimumFractionDigits: 2,
        }
        var dollarString = new Intl.NumberFormat("en-us", formatting_options);

        //User has not expanded shipping options
        shippingTotal = data.orderCharges.filter(x => x.chargeType != "COD").reduce((sum, charge) => sum + charge.amount, 0).toFixed(2);
        var codCharge = data.orderCharges.filter(x => x.chargeType == "COD").map(orderCharge => orderCharge.amount.toFixed(2)).toString() ?? 0;
        if (data.paymentTerms.toLowerCase() == "cod") {
            $('.cod-total').text(codCharge);
        }
        else {
            $('.cod-total').text(0);
        }

        $('.shipping-total').text(dollarString.format(shippingTotal));
        $('.tax-total').text(dollarString.format(data.orderTotalTax));
        $('.order-total').text(dollarString.format(data.orderTotal));
        // update value of the data-box-fee attribute
        $('#codDelivery').attr('data-box-fee', codCharge);

        shippingTotal = shippingTotal > 0 ? (`$${shippingTotal}`) : 'Free'
        //Updates the text on the shipping method to ensure it's proper, as the user may switch to COD and then back to a regular payment method.
        $(`[for='${$("input[name='shippingMethod']:checked").data().shipVia}'`).text(`${data.shipViaDescription} - ${shippingTotal}`)
        //Update the data attribute on the label
        $(`[for='${$("input[name='shippingMethod']:checked").data().shipVia}'`).attr("for", data.shipViaCode)
        //Update the data properties on the users input, as they may have switched from non-cod to COD payment and then back
        $(`input[name="shippingMethod"]:checked`).data().shippingMethod = data.shippingMethod;
        $(`input[name="shippingMethod"]:checked`).data().shipVia = data.shipViaCode;
        $(`input[name="shippingMethod"]:checked`).data().shippingCost = data.shippingCost;
        $(`input[name="shippingMethod"]:checked`).data().shippingCost = data?.orderCharges?.some(x => x.chargeType != "COD") ? data?.orderCharges?.find(x => x?.chargeType != "COD").amount : 0;
    }

    var quoteOrder = function (cartRequested = false) {

        //Spinners should already be spinning
        //orderSummarySpinnersSpin();

        return new Promise(function (fulfilled, rejected) {

            let selectedShippingMethod = $('input[name="shippingMethod"]:checked');
            let shipVia = selectedShippingMethod?.data("shipVia");
            let paymentObject = $("input[name='paymentMethod']").filter(':checked');
            var orderSubmitBtn = $("#btn-place-order").length == 1 ? $("#btn-place-order") : $('.js-checkout-btn');

            $.ajax({
                method: "POST",
                url: "/cart/Quote",
                data: { selectedShippingMethod: shipVia, paymentOption: paymentObject?.data()?.paymentTerm, cartRequested: cartRequested },
                dataType: "json",
            }).done(function (data) {
                var formatting_options = {
                    minimumFractionDigits: 2,
                }
                if (data?.errors?.length > 0) {

                    if (data?.errors?.find(x => x.property?.toLowerCase() == "cart count")) {
                        var cart = { cartCount: 0 }
                        data.cart = cart;
                        site.Cart.checkForEmptyCart(data);
                    }

                    orderSummarySpinnersRemove();

                    $('.shipping-total').text('0.00');
                    if ($('.js-cod-summary').is(":visible")) {
                        $('.cod-total').text('0.00');
                    }
                    $('.tax-total').text('0.00');
                    $('.order-total').text('0.00');
                    $('#orderSubmitError').text(data.errors[0].message);
                    $('.checkout-payment-alert-msg').removeClass('d-none');
                    rejected(data);
                }
                else if (data?.quoteOrderResponse) {
                    $('.checkout-payment-alert-msg').addClass('d-none');
                    //If the user is on the checkout and they have not expanded shippingOptions, we are done processing the data for the OrderSummary at this point
                    if (site.Utilities.onCheckout() && $('.shipping-method-options .toggle-shipping-list').length > 0 && jQuery.active == 0) {
                        orderSummarySpinnersRemove();
                        setOrderSummaryValuesAfterDataReturns(data.quoteOrderResponse)
                    }
                    else if (jQuery.active == 0) {
                        setOrderSummaryValuesAfterDataReturns(data.quoteOrderResponse)
                        orderSummarySpinnersRemove()
                    }

                    $('#continue-to-payment-button').removeClass('disabled');
                    $('#orderSubmitErrorMsg').text('');
                    if (data?.errors?.length > 0) {
                        $('#orderSubmitErrorMsg').text(data?.errors[0].message);
                        $('.checkout-payment-alert-msg').removeClass('d-none');
                    } else {
                        $('.checkout-payment-alert-msg').addClass('d-none');
                    }

                }
                fulfilled(data);
            }).fail(function (data) {
                console.log("Error quoting cart. Response: " + data);
                rejected(data);
            });
        });
    }

    var reselectShippingMethod = function (previousSelectedShippingMethod) {

        $('a.toggle-shipping-list').click();
        $('a.toggle-shipping-list').prop('checked', true);
        calculateShippingCost();
    }

    //toggles buttons that remove/add products to the cart
    var toggleDisableRemoveAndAddForLater = function (x) {
        $('.js-cart-save-for-later, .counter, .js-autoship-frequency, .js-cart-remove, .undo-saved-for-later, .undo-remove-item, .js-cart-update-quantity, .js-saved-to-cart, .js-saved-remove, .js-change-address, #cart-link, #shipping-link, #payment-link, #review-link').each(function () {
            if (x == 'disable') {
                $(this).attr("disabled", "disabled");
                $('.js-cart-remove').attr("background-color", "grey").addClass('disabled-link');
                $('.js-saved-to-cart').attr("background-color", "grey").addClass('disabled-link');
                $('.js-saved-remove').attr("background-color", "grey").addClass('disabled-link');
                $('.fa-trash-alt').attr("color", "grey");

                $('.js-change-address').addClass('disabled-link');
                $('.payment-details-container .continue-to-payment').addClass('disabled-link');
                $('#cart-link, #shipping-link, #payment-link, #review-link').addClass('disabled-link');
                $('.counter').addClass('disabled-span')
            }

            else if (x == 'enable') {
                $(this).removeAttr('disabled');
                $('.js-cart-remove').removeAttr("style").removeClass('disabled-link');
                $('.js-saved-to-cart').removeAttr("style").removeClass('disabled-link');
                $('.js-saved-remove').removeAttr("style").removeClass('disabled-link');
                $('.fa-trash-alt').attr("color", "#00573d");

                $('.js-change-address').removeClass('disabled-link');
                $('.payment-details-container .continue-to-payment').removeClass('disabled-link');
                $('#cart-link, #shipping-link, #payment-link, #review-link').removeClass('disabled-link');
                $('.counter').removeClass('disabled-span')

                //
            }
        });
    }

    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });

    var setReviewSection = function (selectedPayment) {
        let cardType;
        let lastFour;
        let expirationDate;
        let ccAddress;
        let ccCityState;
        let ccHolderName;
        let reviewCC;
        let reviewCCDetails;
        if (typeof selectedPayment == "undefined") {
            selectedPayment = $("input[name='paymentMethod']").filter(':checked');
        }
        let selectedPaymentID = $(selectedPayment).attr('id');
        if (typeof selectedPaymentID != 'undefined') {
            //User selected COD
            if ($(selectedPayment).data().paymentTerm.toLowerCase() == 'cod') {
                reviewCC = 'C.O.D.';
                reviewCCDetails = 'Additional $30.00 fee per box.';
                $('#ccTypes').hide();
            }
            //User selected Net30
            else if (selectedPaymentID?.toLowerCase() == 'net 30') {
                reviewCC = 'Net 30';
                reviewCCDetails = '';
                $('#ccTypes').hide();
            }
        }
        //User selected a paymentProfile
        else {
            $('#ccTypes').show();
            cardType = selectedPayment.parent().find('.cc-last-four').data().cardType;
            lastFour = selectedPayment.parent().find('.cc-last-four').data().lastFour;
            expirationDate = selectedPayment.parent().find('.exp-date').text();
            ccAddress = selectedPayment.parent().find('.card-address').text();
            ccCityState = selectedPayment.parent().find('.card-city-state-zip').text();
            ccHolderName = selectedPayment.parent().find('.card-holder-name').text();

            reviewCC = `${cardType} ending in ${lastFour} | ${expirationDate}`;
            reviewCCDetails = `${ccHolderName.trim()}, ${ccAddress.trim()}, ${ccCityState.trim()}`;

            $('#reviewvisa, #reviewmastercard, #reviewamericanexpress, #reviewdiscover').addClass('d-none')
            //Show the proper icon
            $(`#review` + selectedPayment.parent().find('.cc-last-four').data().cardType.toLowerCase()).removeClass('d-none');
        }

        $('#reviewCC').text(reviewCC);
        $('#reviewCCDetails').text(reviewCCDetails);
    }

    var makeToast = function (title, message) {
        $('#liveToast').find('.toast-title')[0].innerText = '';
        $('#liveToast').find('.toast-body')[0].innerText = '';
        $('#liveToast').find('.toast-title')[0].innerText = title;
        $('#liveToast').find('.toast-body')[0].innerText = message;
        var toastLiveExample = document.getElementById('liveToast');
        var toast = new bootstrap.Toast(toastLiveExample);
        toast.show();
    }

    $(document).on('click', '.js-download', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        if ($(e).is("[disabled]")) {
            return;
        }

        downloadAsync(this);
    })

    /**
     * 
     * @param {HTMLElement} element 
     * @returns {Promise}
     */
    async function downloadAsync(element) {
        var downloadUrl = $(element).attr("href");
        const elementRect = element.getBoundingClientRect();
        const originalHtml = element.innerHTML;
        const spinnerHtml = `<div class="spinner-border spinner-border-sm" role="status"><span class="visually-hidden">Loading...</span></div>`;

        $(element)
            .addClass("disabled")
            .attr("disabled", true)
            .html(spinnerHtml)
            .css("width", elementRect.width + "px");

        try {
            var response = await fetch(downloadUrl, {
                method: "HEAD",
            });

            validateResponse(response);
            window.open(downloadUrl);
        } catch (error) {
            const errorMessage = "Error downloading url: " + downloadUrl;
            console.error(errorMessage);
            const $toastTitle = $('#liveToast').find('.toast-title');
            const $toastBody = $('#liveToast').find('.toast-body');
            $toastTitle.text("Error");
            $toastBody.text(errorMessage);
            const toastLiveExample = document.getElementById('liveToast');
            const toast = new bootstrap.Toast(toastLiveExample);
            toast.show();
        } finally {
            $(element)
                .removeClass("disabled")
                .attr("disabled", null)
                .html(originalHtml)
                .css("width", null);
        }
    }

    function validateResponse(response) {
        if (!response.ok) {
            throw Error(response.statusText);
        }
        return response;
    }

    var setSaveForLater = function () {
        if ($('.saved-item').length == 0) {
            $('.saved-items-empty').removeClass('d-none');
        } else {
            if ($('.saved-item.partType-Product').length > 0) {
                $('#saveForLaterProducts').click();
            } else if ($('.saved-item.partType-Literature').length > 0) {
                $('#saveForLaterLiterature').click();
            } else if ($('.saved-item.partType-Merchandise').length > 0) {
                $('#saveForLaterMerchandise').click();
            } else {
                $('#saveForLaterProducts').click();
            }
        }
    }

    // zero out all price texts on an invalid cart load
    var zeroOrderSummary = function () {
        let zeroed = "0.00"
        // elements on the cart and checkout pages
        $('.cart-subtotal').text(zeroed);
        $('.items-subtotal').text(zeroed);
        $('.order-summary-container .order-total').text(zeroed);

        if (site.Utilities.onCheckout()) { // elements only on the checkout page
            $('.shipping-total').text(zeroed);
            $('.cod-total').text(zeroed);
            $('.tax-total').text(zeroed);
            $('.checkout-container .order-total').text(zeroed);
        }
    }

    function bindCartEvents() {
        /**
         * Begins the operation of removing a line item from the cart.
         * @param {string} partNo
         * @param {number} quantity
         * @param {string} description
         * @param {any} listItemContainer
         * @returns {Promise<void>}
         */
        var removeFromCart = function (
            trigger,
            partNo,
            quantity,
            description,
            listItemContainer
        ) {
            return new Promise(function (fulfilled, rejected) {
                var query = { partNo: partNo, quantity: quantity == 0 ? 1 : quantity, description: description };
                $.ajax({
                    method: 'POST',
                    url: '/cart/RemoveFromCart',
                    dataType: 'json',
                    data: query
                }).done(function (data) {
                    var orderSubmitBtn = $("#btn-place-order").length == 1 ? $("#btn-place-order") : $('.js-checkout-btn');
                    if (typeof listItemContainer != "undefined") {
                        $(listItemContainer).find('.cart-item, .cart-line-messages-container, .compliance').addClass('d-none');
                        listItemContainer.append(data.updatedPartial);
                        let noPartRestrictions = checkPartRestrictions(data.cart);
                        $('.sum-1 .slpSubtotal').data().slpSubtotal = data.cart.orderSLPTotal

                        if (jQuery.active == 0) {
                            toggleDisableRemoveAndAddForLater('enable');
                        }
                        if (noPartRestrictions) {
                            const lineItem = data.cart.parts.find(x => x.partNo === partNo);
                            const removeFromCartEventData = {
                                currency: "USD",
                                value: (lineItem?.salePrice ?? 0) * quantity,
                                remove_from_cart_item: [
                                    {
                                        item_id: partNo,
                                        item_name: (lineItem?.productName ?? "test"),
                                        price: (lineItem?.salePrice ?? 0),
                                        quantity: quantity,
                                    }
                                ]
                            };

                            // gtag("event", "remove_from_cart", removeFromCartEventData);
                            cartState.shoppingCartViewModel = data.cart;
                            checkForEmptyCart(data);
                        }
                        let onCheckout = site.Utilities.onCheckout();
                        listItemContainer.find('.js-cart-update-quantity')[0].value = quantity;
                        if (onCheckout && !noPartRestrictions) {
                            //The user should only hit this if they are on the checkout and have restrictions
                            zeroOrderSummary();
                            toggleDisableRemoveAndAddForLater('enable');
                            enableDisableButton(orderSubmitBtn, site.Utilities.onCheckout() ? orderSubmitBtnText : checkoutBtnText, true);
                            rejected(data);
                        } else if (onCheckout && noPartRestrictions) {
                            fulfilled(data);
                        }
                        else if (!onCheckout && !noPartRestrictions) {
                            orderSummarySpinnersRemove();
                            refreshTotalsWithCartData(data.cart);
                            toggleDisableRemoveAndAddForLater('enable');
                            enableDisableButton(orderSubmitBtn, site.Utilities.onCheckout() ? orderSubmitBtnText : checkoutBtnText, true);
                            fulfilled(data);
                            //This is when the user is on the cart page
                        }
                        else {
                            orderSummarySpinnersRemove();
                            refreshTotalsWithCartData(data.cart);
                            toggleDisableRemoveAndAddForLater('enable');
                            enableDisableButton(orderSubmitBtn, site.Utilities.onCheckout() ? orderSubmitBtnText : checkoutBtnText, false);
                            fulfilled(data);
                        }
                    }
                }).fail(function () {
                    toggleDisableRemoveAndAddForLater('enable');
                });
            });
        }

        /**
         * Begins the operation of adding a line item to the cart.
         * @param {string} partNo The part number.
         * @param {number} quantity The new quantity.
         * @param {string} source ?
         * @param {any} listItemContainer ?
         * @param {any} tileItemContainer ?
         * @param {any} inCartDataPart ?
         * @returns {Promise<void>}
         */

        //Check if all theses are going to be need
        var addToCart = function (
            partNo,
            quantity,
            autoShipFrequency,
            source,
            listItemContainer,
            tileItemContainer,
            inCartContainer,
            propHolders
        ) {
            autoShipFrequency = (autoShipFrequency === "" || isNaN(autoShipFrequency)) ? 0 : parseInt(autoShipFrequency);
            return new Promise(function (fulfilled, rejected) {
                let noPartRestrictions = true;
                var query = { partNo: partNo, quantity: parseInt(quantity), autoShipFrequency: autoShipFrequency, source: source };
                $.ajax({
                    method: "POST",
                    url: "/cart/AddToCart",
                    dataType: "json",
                    data: query
                }).done(/** @type {CartAjaxModelResponse} */function (data) {
                    //handles new messaging
                    var newQuantity = data.cart.parts.find(x => x.partNo == partNo.toString()).partQuantity;

                    const $container = (listItemContainer?.length ?? 0) > 0
                        ? listItemContainer
                        : tileItemContainer;

                    const $lineItemContainer = $container.closest("[data-add-to-cart-container-type]");
                    const $notInCartIcon = $lineItemContainer.find(".not-in-cart-icon");
                    const $inCartIcon = $lineItemContainer.find(".in-cart-icon");
                    const $cartCountBadge = $lineItemContainer.find(".in-cart-count-badge");

                    $notInCartIcon.addClass("d-none");
                    $inCartIcon.removeClass("d-none");
                    $cartCountBadge.removeClass("d-none").text(newQuantity);

                    if (typeof listItemContainer != "undefined") {

                        if (!$('.quick-order-search-container').is(':visible')) {
                            $(listItemContainer).find('.cart-item, .cart-line-messages-container, .compliance').removeClass('d-none');
                            $(inCartContainer).text(newQuantity)
                        }
                    }
                    if (typeof tileItemContainer != "undefined") {

                        let option = $('#tileResults').find("option[value=" + partNo + "]");
                        if ($(option).is(':selected')) {
                            $(inCartContainer).text(newQuantity)
                        }
                    }

                    //handles inCart setting which needs to happen on all the views
                    if (typeof propHolders != "undefined") {
                        for (let i = 0; i < propHolders.length; i++) {
                            let incart = propHolders[i].attr('data-incart') == "" ? 0 : propHolders[i].attr('data-incart');
                            let totalQty = parseInt(incart) + parseInt(quantity);
                            propHolders[i].attr('data-incart', totalQty);
                        }
                    }

                    noPartRestrictions = checkPartRestrictions(data.cart);

                    if ($('.checkout').is(':visible') || $('#shoppingCart').is(':visible')) {
                        if (source == "undo") {
                            if (typeof listItemContainer != "undefined") {
                                $(listItemContainer).find('#undo-remove-item').remove();
                                $(listItemContainer).find('.cart-item, .cart-line-messages-container, .compliance').removeClass('d-none');
                                if (jQuery.active == 0) {
                                    refreshCartPartsQuoteCartData(data);
                                }
                            }
                        } else {
                            listItemContainer.removeAttr("style");
                        }
                    }

                    refreshCartCount();

                    if (noPartRestrictions) {
                        const itemData = data.cart.parts.find(x => x.partNo === partNo.toString());

                        if (itemData === null || itemData === undefined) {
                            throw new Error("Should never reach here...");
                        }

                        const addToCartEventData = {
                            currency: "USD",
                            value: (itemData?.salePrice ?? 0) * quantity,
                            items: [
                                {
                                    item_id: partNo,
                                    item_name: (itemData?.productName ?? ""),
                                    price: itemData.salePrice,
                                    quantity: quantity
                                }
                            ]
                        };
                        // gtag("event", "add_to_cart", addToCartEventData);

                    }
                    cartState.shoppingCartViewModel = data.cart;
                    fulfilled(data);
                }).fail(function (data) {
                    console.log("Error Adding part to cart.");
                    toggleDisableRemoveAndAddForLater('enable');
                    rejected(data);
                });
            });
        }

        /**
         * Shows/hides the restriction message for each line item in the cart,
         * disables/enables the checkout button, and handles the order
         * messages.
         * @param {ShoppingCartViewModel} cart 
         * @returns {boolean} Returns true if no parts block ordering, false
         * if any part blocks ordering.
         */
        var checkPartRestrictions = function (cart) {
            let hasBlockingRestriction = false;

            for (var part of cart.parts) {
                var $partAlert = $(`.alert[data-partno="${part.partNo}"]`);
                var $alertIcon = $($partAlert).find('.alert-icon');
                var $alertText = $($partAlert).find('.alert-text');

                if (part.blocksOrdering) {
                    $partAlert.removeClass("d-none");
                    if ($($partAlert).hasClass('cart-item-alert-grey-msg')) {
                        $($alertIcon).removeClass('fa-info-circle');
                        $($alertIcon).addClass('fa-exclamation-triangle');
                        $($partAlert).removeClass('cart-item-alert-grey-msg');
                        $($partAlert).addClass('cart-item-alert-msg').addClass('checkout-payment-alert-msg');
                        $($partAlert).removeClass('d-none');
                    }
                    else {
                        $($partAlert).addClass('checkout-payment-alert-msg');
                    }
                    $($alertText).text(" " + part.blocksOrderingMessage);
                    hasBlockingRestriction = true;
                }
                else {
                    $partAlert.addClass("d-none");
                }
            }

            let orderSubmitBtn = $("#btn-place-order").length == 1 ? $("#btn-place-order") : $('.js-checkout-btn');

            if (hasBlockingRestriction) {
                $(".js-order-restrictions").removeClass("d-none");
                zeroOrderSummary();
            } else {
                $(".js-order-restrictions").addClass("d-none");
            }

            return !hasBlockingRestriction;
        }

        /**
         * Updates the quantity of a shopping cart line item.
         * @param {string} event
         * @returns {Promise<CartAjaxModel>}
         */
        var updateQuantity = function (event, origin) {
            console.log(event)

            return new Promise(function (fulfilled, rejected) {
                console.log(event)
                let trigger = event.currentTarget;
                let itemAnchor = $(trigger).parents('.js-item-anchor')
                console.log(trigger)
                let quantity = $(trigger).val();
                let autoShipFrequency = $(itemAnchor).find('.js-autoship-frequency').val();
                let type = $(trigger).data("type");
                var orderSubmitBtn = $("#btn-place-order").length == 1 ? $("#btn-place-order") : $('.js-checkout-btn');


                if (quantity > 0) {
                    $(trigger).closest('.js-cart-quantity').attr('data-quantity', $(trigger).val());
                    $(trigger).parent().parent().parent().find('.item-part-number-data').attr("data-incart", $(trigger).val());
                }

                const isUpdateCartRequest = typeof quantity != 'undefined'
                    && quantity != ""
                    && quantity != 0;
                    //&& ((type != "dropdown") || (type == "dropdown" && quantity != 10));
                if (isUpdateCartRequest) {
                    let alertContainer = $(trigger).parent().parent().parent().children(".js-cart-item-alert");
                    let partNo = $(trigger).data("partno").toString();

                    let query = { PartNo: partNo, Quantity: quantity, AutoShipFrequency: autoShipFrequency };
                    if (site.Utilities.onCheckout()) {
                        orderSummarySpinnersSpin();
                        subtotalActivateSpinners(true);
                    }
                    $.ajax({
                        method: "PUT",
                        url: "/cart/UpdateCart",
                        dataType: "json",
                        data: query
                    }).done(/** @type {CartAjaxModelResponse} */ function (updateCartReturnData) {
                        //Handles the response from updating the cart
                        fulfilled(updateCartReturnData);
                        ga4UpdateCartFunc(updateCartReturnData, trigger, quantity, partNo);
                    }).fail(function (data) {
                        toggleDisableRemoveAndAddForLater('enable');
                        rejected();
                    });
                }
                else if (quantity == 0) {
                    orderSummarySpinnersSpin();
                    subtotalActivateSpinners(true);
                    quantity = $(trigger).closest('.js-cart-quantity').data('quantity');
                    $(trigger).parent().parent().attr('data-quantity', $(trigger).val());
                    let partNo = $(trigger).data("partno");
                    let title = $(trigger).data("description");
                    let listItemContainer = $(trigger).closest('.js-line-item');
                    
                    $.when(removeFromCart(trigger, partNo, quantity, title, listItemContainer)).then(function (data) {
                        fulfilled(data);
                    }).catch(function () {
                        orderSummarySpinnersRemove()
                        subtotalActivateSpinners(false);
                        rejected();
                    });
                }
                else {
                    rejected("Should never reach here but included just in case.");
                    orderSummarySpinnersRemove()
                    subtotalActivateSpinners(false);
                }
            });
        }

        $('#product-quantity-input').keyup(function (e) {
            if ($(this).val() == "0" || $(this).val() == 0) {
                $(this).val('');
            }
            else {
                checkQuickOrderCartBtn();
            }
        })

       

        /**
         * The actions to perform after items are added/removed from the cart.
         * NOTE: This should ONLY be invoked on the cart and checkout
         * pages, nowhere else.
         * NOTE: The returned promise will be rejected if there are any blocking
         * part restrictions.
         * @param {HTMLElement} trigger 
         * @param {CartAjaxModel} updateCartReturnData 
         * @param {boolean} cartRequested 
         * @returns {Promise<CartAjaxModel>}
         */
        var addAndRemoveFromCartPostUpdate = function (trigger, updateCartReturnData, cartRequested = false) {
            var orderSubmitBtn = $("#btn-place-order").length == 1 ? $("#btn-place-order") : $('.js-checkout-btn');
            let alertContainer = $(trigger).parent().parent().parent().children(".js-cart-item-alert");
            let selectedShippingMethod = $('input[name="shippingMethod"]:checked');
            return new Promise((fulfilled, rejected) => {
                if (site.Utilities.onCheckout()) {
                   
                    if (!updateCartReturnData.cart.parts.find(x => x.blocksOrdering == true)) {
                        //Has the user requested all shipping options? If so, we need to get the new rates after they've updated the quantity, so the UI is proper if they check the Shipping page fpr presentation
                        if ($('.shipping-method-options .toggle-shipping-list').length === 0) {
                            $.when(site.Cart.quoteOrder(cartRequested)).then(function (quoteResponseData) {
                                var quoteOrderResponse = quoteResponseData.quoteOrderResponse;
                                $.when(site.Cart.getShippingRates(quoteOrderResponse.shipViaCode, selectedShippingMethod)).then(function (shippingDataResponse) {
                                    if (quoteOrderResponse != null) {

                                        refreshCartPartsQuoteCartData(quoteResponseData);
                                        refreshCartCount();

                                        // Updating the UI.
                                        let noPartRestrictions = checkPartRestrictions(updateCartReturnData.cart);
                                        if (!noPartRestrictions) {
                                            alertContainer.html(updateCartReturnData.updatedPartial);
                                            orderSummarySpinnersRemove();
                                            subtotalActivateSpinners(false);
                                        }
                                        toggleDisableRemoveAndAddForLater('enable');
                                        enableDisableButton(orderSubmitBtn, site.Utilities.onCheckout() ? orderSubmitBtnText : checkoutBtnText, false);
                                        noPartRestrictions ? fulfilled(quoteResponseData) : rejected(quoteResponseData);
                                    }
                                    else {
                                        enableDisableButton(orderSubmitBtn, site.Utilities.onCheckout() ? orderSubmitBtnText : checkoutBtnText, true);
                                    }
                                });
                            })
                        } else {

                            $.when(site.Cart.quoteOrder(cartRequested)).then(function (data) {
                                if (data.quoteOrderResponse != null) {
                                    // Updating the UI.
                                    updateCartReturnData.cart["orderTotalTax"] = data.quoteOrderResponse.orderTotalTax;
                                    updateCartReturnData.cart["orderTotalFees"] = data.quoteOrderResponse.orderTotalFees;
                                    refreshCartPartsQuoteCartData(data);
                                    refreshCartCount();
                                    let noPartRestrictions = checkPartRestrictions(updateCartReturnData.cart);
                                    if (!noPartRestrictions) {
                                        alertContainer.html(updateCartReturnData.updatedPartial);
                                    }
                                    toggleDisableRemoveAndAddForLater('enable');
                                    enableDisableButton(orderSubmitBtn, site.Utilities.onCheckout() ? orderSubmitBtnText : checkoutBtnText, false);
                                    noPartRestrictions ? fulfilled(data) : rejected(data);
                                }
                                else {
                                    enableDisableButton(orderSubmitBtn, site.Utilities.onCheckout() ? orderSubmitBtnText : checkoutBtnText, true);
                                }
                            })
                        }
                    } else {
                        let noPartRestrictions = checkPartRestrictions(updateCartReturnData.cart);
                        orderSummarySpinnersRemove();
                        subtotalActivateSpinners(false);
                        refreshTotalsWithCartData(updateCartReturnData.cart)
                        refreshCartCount();
                        toggleDisableRemoveAndAddForLater('enable');
                        if (noPartRestrictions) {
                            fulfilled();
                        } else {
                            alertContainer.html(updateCartReturnData.updatedPartial);
                            zeroOrderSummary();
                            rejected(updateCartReturnData);
                        }
                    }
                }
                else {
                    refreshTotalsWithCartData(updateCartReturnData.cart)
                    refreshCartCount();
                    let noPartRestrictions = checkPartRestrictions(updateCartReturnData.cart)
                    toggleDisableRemoveAndAddForLater("enable");
                    enableDisableButton(orderSubmitBtn, site.Utilities.onCheckout() ? orderSubmitBtnText : checkoutBtnText, !noPartRestrictions);
                    subtotalActivateSpinners(false);
                    fulfilled(updateCartReturnData);
                }
            })
        }

        /**
         * Emits the GA4 event for google analytics.
         * @param {ShoppingCartViewModel} updateCartReturnData 
         * @param {HTMLElement} objThatTriggeredEvent 
         * @param {number} quantity 
         * @param {string} partNo 
         */
        var ga4UpdateCartFunc = function (updateCartReturnData, objThatTriggeredEvent, quantity, partNo) {
            // Emit the GA4 event.
            if (partNo == null) {
                try {
                    partNo = $(objThatTriggeredEvent).data("partno").toString();
                }
                catch (error) { console.log(`An error occured reading the partNo ${partNo}. Error - ${error}`) }
            }
            const lineItem = updateCartReturnData.cart?.parts.find(x => x.partNo === partNo);
            const previousLineItem = cartState.shoppingCartViewModel?.parts?.find(x => x.partNo === partNo);
            const isQuantityIncreasing = (previousLineItem?.partQuantity ?? 0) < quantity;

            const quantityChange = Math.abs(quantity - (previousLineItem?.partQuantity ?? 0));
            const value = (previousLineItem.salePrice ?? lineItem.salePrice) * quantityChange;
            const ga4EventType = isQuantityIncreasing ? "add_to_cart" : "remove_from_cart";

            const ga4EventValue = {
                currency: "USD",
                value: value,
                items: [{
                    item_id: partNo,
                    item_name: lineItem.productName,
                    price: lineItem.salePrice,
                    quantity: quantityChange,
                }]
            };

            // gtag("event", ga4EventType, ga4EventValue);

            // Update the internal cart state with the new cart.
            cartState.shoppingCartViewModel = updateCartReturnData.cart;

            $(objThatTriggeredEvent)
                .closest("[data-add-to-cart-container-type]")
                .find('.item-part-number-data')
                .attr("data-incart", quantity);
        }

        /**
         * Begins the operation of finalizing the purchase.
         * @param {string} paymentTerm
         * @param {string} paymentProfileId
         * @param {string} shipVia
         * @param {string} poNumber
         * @returns {Promise<void>}
         */
        var submitOrder = function (paymentTerm, paymentProfileId, shipVia, poNumber) {
            return new Promise(function (fulfilled, rejected) {
                $.ajax({
                    method: "POST",
                    url: "/cart/submit",
                    dataType: "json",
                    data: { paymentTerm: paymentTerm, paymentProfileId: paymentProfileId, shipVia: shipVia, poNumber: poNumber }
                }).done(function (data) {

                    if (data?.errors?.length > 0 || data?.isCart) {
                        if (data?.isCart) {
                            checkPartRestrictions(data);
                        }
                        else {
                            var orderRestrictionHTML = ""
                            var orderRestrictions = data.errors.map(orderRestriction => orderRestriction.message);
                            //check length before setting
                            if (orderRestrictions.length > 0) {
                                orderRestrictions.forEach(message => {
                                    orderRestrictionHTML += `<small><i class="fas fa-exclamation-triangle"></i> <span>${message}</span></small><br>`;
                                });
                                $('#orderSubmitError').append(orderRestrictionHTML);
                                $('.checkout-payment-alert-msg').removeClass('d-none').show();
                            }
                        }
                        $('#orderSubmitError').focus();
                        $(window).scrollTop(0);
                        rejected();
                    }

                    else {
                        let orderDetail = data.response; // SubmitOrderResponseDto

                        // if for GTM is not running, redirect to thank you page
                        // otherwise redirect is handled as eventCallBack.
                        if (!window.google_tag_manager) {
                            createForm("/checkout/thank-you").submit();
                            fulfilled();
                        }
                        // GTM eCommerce Purchase Event
                        window.dataLayer = window.dataLayer || [];
                        dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
                        dataLayer.push({
                            event: 'purchase',
                            user_id: orderDetail.customerId,
                            ecommerce: {
                                transaction_id: orderDetail.orderNo,
                                value: orderDetail.orderSubTotal,
                                tax: orderDetail.orderTotalTax,
                                shipping: orderDetail.orderTotalFees,
                                currency: 'USD',
                                items: orderDetail.lines.map((line, index) => {
                                    return {
                                        item_id: line.partNo,
                                        item_name: line.partDescription,
                                        quantity: line.quantityOrdered,
                                        price: line.salePrice,
                                        discount: line.unitDiscount,
                                        affiliation: orderDetail.salesmanId,
                                        index: index
                                    };
                                })
                            },
                            'eventCallback': function () {
                                createForm("/checkout/thank-you").submit();
                                fulfilled();
                            }
                        });
                    }
                }).fail(function (data) {
                    rejected(data);
                });
            });
        }

        var addQuickOrderToCart = function () {
            checkQuickOrderCartBtn();

            var date = new Date().toLocaleString('en-US', {
                hour12: true,
            });

            var partNo = $('#product-search-input').attr('data-part-number');
            var description = $('#product-search-input').attr('data-part-description');
            var qtyInput = parseInt($('#product-quantity-input').val(), 10);
            var qtyIsUnderMax = !$('#product-quantity-input') || $('#product-quantity-input').attr('max') === '' || qtyInput <= parseInt($('#product-quantity-input').attr('max'));

            if (partNo != "undefined" && $('#product-search-input') && $('#product-search-input').val() !== '' && qtyIsUnderMax && qtyInput > 0) {
                $('#addToCart-alert-msg').addClass('d-none');
                var messageContainer = $('.js-cart-message');

                var quickOrder = "";
                quickOrder += (`<div class="row px-4 px-md-5">`);
                quickOrder += (`<div class="col d-block d-sm-flex align-items-center px-0 py-2">`);
                quickOrder += (`<p class="product-number mb-0 me-2">${partNo}</p>`);
                quickOrder += (`<p class="product-name mb-0">${description}</p>`);
                quickOrder += (`<p class="product-cart-info mb-0 ms-auto text-muted"><i>${qtyInput} added to cart <span class="ms-2">${date}</span></i></p></div></div>`);
                $('.line-items-container').prepend(quickOrder);
                $('.empty-quick-order').remove();

                $('#product-search-input').prop('disabled', true);
                $('#product-quantity-input').prop('disabled', true);
                $('.js-quickOrder-add-cart').prop('disabled', true);

                $.when(addToCart(partNo, qtyInput, 0, "", messageContainer)).then(function () {
                    $('#product-search-input').prop('disabled', false);
                    $('#product-quantity-input').prop('disabled', false);
                    $('#part-search-container').html('');
                    $('#product-quantity-input').val("");
                    $('#product-search-input').val("");
                    $('.notice-message').html("");
                    $('#search-alert-msg').text("");
                    $('#search-alert-msg').addClass('d-none');
                    $('#product-search-input').focus();
                });

            } else {
                $('#addToCart-alert-msg').removeClass('d-none');
            }
        }
        console.log("addToCart")
        /**
         * Click event handler for adding a product to the cart.
         * addProductToCart takes into account that hasRestriction has been
         * called when theres a qty provided
         * @param {Event} e 
         * @returns {void}
         * @this {HTMLElement}
         */
        var addProductToCart = function (e) {

            e.stopImmediatePropagation();

            let clickedBtn = $(this);
            let btnText = clickedBtn.text();
            enableDisableButton(clickedBtn, 'Adding to Cart', true);
            let wrapperParent = $(this).closest('[data-add-to-cart-container-type]');
            let quantity = $(wrapperParent).find('.quantity-select').val();
            let autoShipFrequency = $(wrapperParent).find('.js-autoship-frequency').val();

            /** @type {"list"|"tile"|"product-hero"|"lineitem"|"global"} */
            let containerType = wrapperParent.data("addToCartContainerType");
            //all theses need to be set to add to cart
            let partNo;
            let otherBtn;
            let tileMessageContainer;
            let listMessageContainer;
            let inCartMessage;
            let maxQuantityMessage;
            let inCartContainer;
            let isAutoShipConfigured;
            //groups all the propHolders together to send through to add to
            // cart to update incart value
            let propHolders = [];

            if (containerType === "list") {

                console.log("list")
                var cardHeader = $(this).parents().filter('.product-card');
                isAutoShipConfigured = cardHeader.find('.js-autoship-enable').is(':checked');
                console.log(isAutoShipConfigured)
                if (isAutoShipConfigured) {
                    autoShipFrequency = cardHeader.find('.subscribe-and-save-frequency-selector :selected').val();
                }
                else {
                    autoShipFrequency = 0;
                }
                var itemPartNumberEl = wrapperParent.find(".item-part-number-data");
                partNo = itemPartNumberEl[0].dataset.part;
                var tileOption = $('#tileResults').find("option[value=" + partNo + "]");
                otherBtn = $(tileOption).parent().parent().parent().parent().find('button');
                listMessageContainer = $(wrapperParent).find('.js-cart-message');
                inCartContainer = $(this).parent().find('.in-cart-count-badge');
                tileMessageContainer = $(wrapperParent).find('.js-cart-message');

                propHolders.push(itemPartNumberEl);
                propHolders.push(tileOption);
            }
            else if (containerType === "tile") {
                console.log("tile")
                var cardHeader = $(this).parents().filter('.product-card');
                isAutoShipConfigured = cardHeader.find('.js-autoship-enable').is(':checked');
                console.log(isAutoShipConfigured)
                if (isAutoShipConfigured) {
                    autoShipFrequency = cardHeader.find('.subscribe-and-save-frequency-selector :selected').val();
                }


                let partsDropdown = $(wrapperParent).find('.parts-dropdown').find(':selected');
                partNo = partsDropdown.val();

                otherBtn = $('#listResults').find("button[id*=" + partNo + "]");
                let listPropHolder = $('#listResults').find("div[data-part=" + partNo + "]");

                tileMessageContainer = $(wrapperParent).find('.js-cart-message');
                inCartContainer = $(this).parent().find('.in-cart-count-badge');
                propHolders.push(partsDropdown);
                propHolders.push(listPropHolder);
            }
            else if (
                containerType === "global"
                || containerType === "product-hero"
                || containerType === "lineitem"
            ) {
                let partsDropdown = $(wrapperParent).find('.parts-dropdown').find(':selected');
                partNo = partsDropdown.val();

                tileMessageContainer = $(wrapperParent).find('.js-cart-message');
                listMessageContainer = $(wrapperParent).find('.js-cart-message');
                inCartContainer = $(this).parent().find('.in-cart-count-badge');

                propHolders.push(partsDropdown);
            }


            if (parseInt(quantity) == 0) {
                $(wrapperParent).find('.quantity-select').val('');
                clickedBtn.removeClass('disabled');
                enableDisableButton(clickedBtn, btnText, false);
                return;
            }
            if (quantity == "") {
                quantity = "1";
                let quantitySelect = $(wrapperParent).find('.quantity-select');
                var restrictions = site.Utilities.determineAddToCartElementsRestrictions(quantitySelect, quantity);
                if (!restrictions.canAddToCart) {
                    enableDisableButton(clickedBtn, 'Add to Cart', true);
                    if (restrictions.restrictionType === "MAX_QUANTITY") {
                        if (restrictions.triggerType == "tile" || restrictions.triggerType == "list") {
                            $("#" + restrictions.cartBtn).removeClass("d-none");
                            inCartMessage = "";
                            if (restrictions.incart == 0) {

                            } else {
                                inCartMessage = 'Currently in Cart: ' + restrictions.incart;
                            }
                            restrictions.inCartMessageContainer.text(inCartMessage);
                            if (!$('#liveToast').is(":visible")) {
                                var title = restrictions.propHolder[0].dataset.title;
                                site.Cart.makeToast(title, maxQuantityMessage);
                            }
                        } else if (restrictions.triggerType === "global" || restrictions.triggerType === "detail") {
                            $("#" + restrictions.cartBtn).prop('disabled', true);
                            restrictions.restrictionContainer.text(maxQuantityMessage);
                        }
                    }

                }
            }
            $.when(addToCart(partNo, quantity, autoShipFrequency, "", listMessageContainer, tileMessageContainer, inCartContainer, propHolders)).then(function () {
                const selectBox = wrapperParent.find('.quantity-select');
                selectBox.val('1');
                enableDisableButton(clickedBtn, 'Add to Cart', false);
                const restrictionData = site.Utilities.determineAddToCartElementsRestrictions(clickedBtn, 0);
                site.Utilities.displayBtnAndMessages(restrictionData);
            }).catch(function (error) {
                var inCart = propHolders[0].attr('data-incart');
                var maxQTY = propHolders[0].attr('data-part-maxquantity');
                var totaltQty = parseInt(inCart) + parseInt(quantity);
                if (totaltQty < parseInt(maxQTY)) {
                    clickedBtn.removeClass('disabled');
                    enableDisableButton(clickedBtn, btnText, true);
                }

                const restrictionData = site.Utilities.determineAddToCartElementsRestrictions(clickedBtn, inCart);
                site.Utilities.displayBtnAndMessages(restrictionData);
            });

            $(this).blur();
        }

        $(document).on('click', '.increaseCount', function (e) {
            var cardHeader = $(this).parents().filter('.js-item-anchor');
            if (timeoutID) {
                clearTimeout(timeoutID);
            }
            var qtyInput = $(cardHeader).find('.quantity-select')
            var maxQty = $(cardHeader).find('.quantity-select').data().maxquantity ?? 2000;

            if (qtyInput == null || qtyInput.val() === 'undefined' || qtyInput.val() === 'NaN' || parseInt(qtyInput.val()) == maxQty) {
                return;
            }
            $(qtyInput).val(parseInt($(qtyInput).val()) + 1);

            if ($('#shoppingCart').is(':visible')) {
               timeoutID = setTimeout(function () {
                   $(cardHeader).find('.js-cart-update-quantity').trigger('blur', e);
               }, 500);
               return;
            }
        });


        $(document).on('click', '.decreaseCount', function (e) {
            var cardHeader = $(this).parents().filter('.js-item-anchor');
            if (timeoutID) {
                clearTimeout(timeoutID);
            }

            var qtyInput = $(cardHeader).find('.quantity-select');

            if (qtyInput == null || qtyInput.val() === 'undefined' || qtyInput.val=== 'NaN' || parseInt($(qtyInput).val()) == 1) {
                return;
            }

            $(qtyInput).val(parseInt($(qtyInput).val()) - 1);

            if ($('#shoppingCart').is(':visible')) {
                timeoutID = setTimeout(function () {
                    $(cardHeader).find('.js-cart-update-quantity').trigger('blur', e);
                }, 500);
            }
        });

        $(document).on('click', '.js-cart-add-list', function (e) { addProductToCart.call(this, e); })

        $(document).on('click', '.js-cart-add', function (e) { addProductToCart.call(this, e); })

        $(document).on('click', '.js-cart-add-product-page', function (e) { addProductToCart.call(this, e); })


        $(document).on('change', '.js-autoship-frequency', function (e) {
            var event = e;
            var cardHeader = $(this).parents().filter('.js-item-anchor');
            if ($(this).val() > 0) {
                $(cardHeader).find('.js-striked-through-price').removeClass('d-none').removeClass('d-xl-none');
                $(cardHeader).find('.js-discount-text').removeClass('d-none');
            }
            else {
                $(cardHeader).find('.js-striked-through-price').addClass('d-none').addClass('d-xl-none');
                $(cardHeader).find('.js-discount-text').addClass('d-none');
            }
            if ($('#shoppingCart').is(':visible')) {
                    $(cardHeader).find('.js-cart-update-quantity').trigger('blur', event);
            }

        });

        $(document).on('click', '.js-checkout-btn', function (e) {
            var submitBtn = $(this);
            submitBtn.addClass('disabled')
            submitBtn.prop('disabled', true);
            submitBtn.addClass("js-disabled").addClass("disabled");
            submitBtn.text('');
            submitBtn.append(loadingSpinner);
            window.location.href = "/checkout/shipping";
            e.stopImmediatePropagation();
        })

        console.log("enable auto")
        $(document).on('click', '.js-autoship-enable', function (e) {
            e.stopImmediatePropagation();
            var cardHeader = $(this).parents().filter('.js-item-anchor');
            $(cardHeader).find('.js-learn-more').removeClass('d-none');
            $(cardHeader).find('.subscribe-and-save-frequency-selector').removeClass('d-none');
            if (!$('#listView').is(':visible')) {
                $(cardHeader).find('.js-striked-through-price').removeClass('d-none').removeClass('d-xl-none');
                $(cardHeader).find('.js-discount-text').removeClass('d-none');
            }
        }) //tileResults

        $(document).on('click', '.js-one-time', function (e) {
            e.stopImmediatePropagation();
            var cardHeader = $(this).parents().filter('.js-item-anchor');
            $(cardHeader).find('.subscribe-and-save-frequency-selector').addClass('d-none');
            $(cardHeader).find('.js-learn-more').addClass('d-none');
            if (!$('#listView').is(':visible')) {
                $(cardHeader).find('.js-striked-through-price').addClass('d-none').addClass('d-xl-none');
                $(cardHeader).find('.js-discount-text').addClass('d-none');
            }

        })

        

        $('#saveForLaterProducts').on('click', function (e) {
            $('#saveForLaterProducts').addClass('active');
            $('#saveForLaterLiterature').removeClass('active');
            $('#saveForLaterMerchandise').removeClass('active');

            $('.partType-Merchandise').hide();
            $('.partType-Literature').hide();
            $('.partType-Product').show();
        });

        $('#saveForLaterLiterature').on('click', function (e) {
            $('#saveForLaterProducts').removeClass('active');
            $('#saveForLaterLiterature').addClass('active');
            $('#saveForLaterMerchandise').removeClass('active');

            $('.partType-Merchandise').hide();
            $('.partType-Product').hide();
            $('.partType-Literature').show();
        });

        $('#saveForLaterMerchandise').on('click', function (e) {
            $('#saveForLaterProducts').removeClass('active');
            $('#saveForLaterLiterature').removeClass('active');
            $('#saveForLaterMerchandise').addClass('active');

            $('.partType-Literature').hide();
            $('.partType-Product').hide();
            $('.partType-Merchandise').show();
        });

        $('.quantity-select').on("keyup", function (e) {
            if (e.which == 13) {
                let $wrapperParent = $(this).closest('.add-to-cart-wrapper');

                let listAddCartBtn = $wrapperParent.find('.js-cart-add-list');
                let productAddCartBtn = $wrapperParent.find('.js-cart-add-product-page');
                let searchAddCartBtn = $wrapperParent.find('.js-cart-add');

                if (listAddCartBtn && listAddCartBtn.length > 0) {
                    // Tab to the button instead of adding to the cart
                    // addProductToCart.call(this, e, true);

                    listAddCartBtn.focus();
                }
                else if (productAddCartBtn && productAddCartBtn.length > 0) {
                    // Tab to the button instead of adding to the cart
                    // addProductToCart.call(this, e, false);

                    $(productAddCartBtn).focus();
                }
                else if (searchAddCartBtn && searchAddCartBtn.length > 0) {
                    // Tab to the button instead of adding to the cart
                    // addProductToCart.call(this, e, false);

                    $(searchAddCartBtn).focus();
                }
            }
        })

        function quickViewDataAsync(data) {

            if ((data?.guid === 'undefined' && data?.guid?.length < 0) || (data?.slug === 'undefined' && data?.slug?.length < 0)) {
                throw new Error("Either the argument 'data.guid' or 'data.slug' must not be null/empty.");
            }

            let url = "/products/quickview?productSlug=";

            if (data.type === "guid") {
                url += data.guid;
            } else if (data.type === "slug") {
                url += data.slug;
            }

            return fetch(url, {
                method: "GET",
            })
                .then(function (response) {
                    if (!response.ok) {
                        throw new Error("Failed to load parts");
                    }
                    return response.json();
                });
        }
        function lowerSnakeCaseNameTransformer(str) {
            let convertedStr = str.replace(/[A-Z]/g, (substr) => {
                return "_" + substr.toLocaleLowerCase();
            }).replace(/[^a-z_]/g, '_').replace(/_{2,}/g, '_');

            if (convertedStr.startsWith('_')) {
                convertedStr = convertedStr.substring(1);
            }

            if (convertedStr.endsWith('_')) {
                convertedStr = convertedStr.substring(0, convertedStr.length - 1);
            }

            return convertedStr;
        }

        function clearQuickViewModal() {
            $("#quickDesc").text("");
            $("#quickViewHeader").text("");
            $("#quickLink").attr('href', "");
            $("#productImg").attr("src", "");
            $("#supplementFactsImage").attr("src", "");
            $("#suggestedUse").html("");
            $("#specialInfo").html("");
            $("#warnings").html("");
            $("#cautions").html("");
            $("#nutriants").html("");
            $("#contradictions").html("");
            $("#consultMessage").html("");
            $("#nutrientsIngredients").html("");
            $("#servingSize").html("");
            $("#mineralsAndVitamins").html("");
            $("#directionsForUse").html("");
        }

        function populateModal(data, brand) {
            $("#warnings").html(data.warnings);
            $("#cautions").html(data.cautions);
            $("#consultMessage").html(data.consultMessage);

            if (brand === undefined || brand === null) {
                brand = data.classDesignation;
            }

            if (brand.toUpperCase() === 'VET') {
                $('.supplement-facts__title').hide();
                $('#supplementFactsImage').hide();
                $("#nutrientsIngredients").html(data.nutrientsIngredients);
                $('#servingSize').html(data.servingSize);
                $('#mineralsAndVitamins').html(data.mineralsAndVitamins);
                if (data.species == "Equine") {
                    $("#footnotes").html(data.footnotes);
                }
            } else {
                if (data.productNutritionLabel.length > 0) {

                    $('.supplement-facts__title').show();
                    $('#supplementFactsImage').show();
                    $("#supplementFactsImage").attr("src", data.productNutritionLabel);
                }
                $("#suggestedUse").html(data.suggestedUse);
                $("#specialInfo").html(data.specialInformation);
                $("#nutriants").html(data.nutriants);
                if (brand == 'MH') {
                    $("#contradictions").html(data.contraindications);
                }
            }
            $("#quickLoadingContainer").hide();
            $("#quickContent").show();
        }


        function loadProductAsync(data) {
            clearQuickViewModal();

            $("#quickLoadingContainer").show();
            $("#quickContent").hide();
            $("#errorContent").hide();
            quickViewDataAsync(data).then(data => {
                populateModalHeader(data);
                // populateModal(data, brand); // Where does brand come from?
                populateModal(data);
            })
                .catch(data => {
                    if (data.abortSignal?.aborted ?? false) {
                        $("#quickLoadingContainer").hide();
                        $("#errorContent").show();
                        return;
                    }

                    $("#quickLoadingContainer").hide();
                    $("#errorContent").show();
                });
        }

        function populateModalHeader(data) {
            $("#quickDesc").text(data.productDescription);
            $("#quickViewHeader").text(data.productName);
            $("#quickLink").attr('href', data.productSlug.includes("/products") ? data.productSlug : "/products/" + data.productSlug);
            if (data.image.length > 0) {
                $("#productImg").attr("src", data.image);
            }
        }

        function readElementAttributes(
            element,
            attributePrefix,
            result,
            nameTransformer
        ) {
            if (element === null || element === undefined) {
                throw new Error('The argument "element" cannot be null nor undefined.');
            } else if (attributePrefix === null || attributePrefix === undefined || attributePrefix === '') {
                throw new Error('The argument "attributePrefix" cannot be null, undefined, nor empty.');
            } else if (result === null || result === undefined) {
                throw new Error('The argument "result" cannot be null nor undefind.');
            }

            for (let attr of element.attributes) {
                if (!attr.name.startsWith(attributePrefix)) {
                    continue;
                }

                let keyName = attr.name.substring(attributePrefix.length);

                if (nameTransformer) {
                    keyName = nameTransformer(keyName);
                }

                // This is to decode html entities and any html encoded bits. The
                // decodeURI and decodeURIComponent functions only decode html
                // encoded strings, not entites.
                const value = $("<textarea />").html(attr.value).text();

                // Don't let parent attributes override the child attributes.
                // Instead convert it to an array and append the parent value to
                // the end of the array.
                if (keyName in result) {
                    if (!Array.isArray(result[keyName])) {
                        result[keyName] = [result[keyName]];
                    }

                    result[keyName].push(value);
                } else {
                    result[keyName] = value;
                }
            }
        }

        function getGoogleAnalyticsData($element) {
            if ($element === null || $element === undefined) {
                throw new Error('The argument "$element" cannot be null nor undefind.');
            }

            const attributePrefix = 'data-ga-';
            const result = {};

            if ($element.length > 0) {
                readElementAttributes($element[0], attributePrefix, result, lowerSnakeCaseNameTransformer);
            }

            $element.parents().each(function () {
                readElementAttributes(this, attributePrefix, result, lowerSnakeCaseNameTransformer);
            });

            return result;
        }

        $(document).on('click', '.js-quickOrder-add-cart', addQuickOrderToCart)

        $(document).on('click', '.js-cart-remove', function (e) {
            e.stopImmediatePropagation();
            const isCheckout = site.Utilities.onCheckout();
            let submitBtn = isCheckout ? $("#btn-place-order") : $('.js-checkout-btn');
            enableDisableButton(submitBtn, isCheckout ? loadingSpinner : "Validating Order", true);
            toggleDisableRemoveAndAddForLater('disable');
            orderSummarySpinnersSpin();
            subtotalActivateSpinners(true);
            let partNo = $(this).data("partno");
            let quantityContainer = $(this).closest('.js-cart-quantity');
            let quantity = quantityContainer.find('.quantity-select').val();
            let title = $(this).data("description");
            let listItemContainer = $(this).closest('.js-line-item');
            $.when(removeFromCart(e, partNo, quantity, title, listItemContainer)).then(function (updateCartReturnData) {
                var cartRequested = true;
                return addAndRemoveFromCartPostUpdate(e, updateCartReturnData, cartRequested).catch(function (data) {
                    zeroOrderSummary()
                    toggleDisableRemoveAndAddForLater('enable');
                    enableDisableButton(submitBtn, site.Utilities.onCheckout() ? orderSubmitBtnText : checkoutBtnText, true);

                })
            })
        })

        $(document).on('click', '.js-saved-remove', function (e) {
            e.stopImmediatePropagation();
            toggleDisableRemoveAndAddForLater('disable');
            let $this = $(this);
            let partNo = $this.data("partno");
            let productName = $this.data("productname");
            let quantity = $this.data("quantity");
            let $lineItem = $this.closest('.saved-item');

            $.ajax({
                method: 'POST',
                url: '/cart/RemoveFromSaveForLater',
                contentType: "application/x-www-form-urlencoded",
                data: {
                    partNo: partNo
                }
            }).done(function (data) {
                toggleDisableRemoveAndAddForLater('enable');
                $lineItem.html('<div id="undo-remove-item" class="row cart-item align-items-start justify-content-xl-between py-4"><div class= "col-md-6 col-xl-8" ><p class="mb-0">' + productName + ' was removed from Your Saved Items <button data-partno=' + partNo + ' data-quantity=' + quantity + ' data-productName=' + productName + '" class="add-to-saved-for-later">Undo</button></p></div ></div > ');
            }).fail(function (error) {
                console.error("Error removing part from cart.");
                console.error(error);
                toggleDisableRemoveAndAddForLater('enable');
            });
        })

        $(document).on('click', '.js-cart-save-for-later', function (e) {
            e.stopImmediatePropagation();
            orderSummarySpinnersSpin();
            subtotalActivateSpinners(true);
            const isCheckout = site.Utilities.onCheckout();
            let orderSubmitBtn = isCheckout ? $("#btn-place-order") : $('.js-checkout-btn');
            toggleDisableRemoveAndAddForLater('disable');
            enableDisableButton(orderSubmitBtn, isCheckout ? loadingSpinner : "Validating Order", true);
            let partNo = $(this).data("partno");
            let productName = $(this).data("productname");
            let itemCategory = $(this).data("itemcategory");
            let quantityContainer = $(this).closest('.js-cart-quantity');
            let quantity = quantityContainer.find('.quantity-select').val();
            let lineItem = $(this).closest('.js-line-item');
            var query = { PartNo: partNo, Quantity: parseInt(quantity) };
            $.ajax({
                method: "POST",
                url: "/cart/FromCartToSaved",
                dataType: "json",
                data: query
            }).then(function (data) {
                checkForEmptyCart(data);
                $(lineItem).find('.cart-item, .cart-line-messages-container, .compliance').addClass('d-none');
                lineItem.append('<div id="undo-remove-item" class="row cart-item align-items-start justify-content-xl-between border-top py-4"><div class= "col-md-6 col-xl-8" ><p class="mb-0">' + productName + ' was moved to Your Saved Items <button data-partno=' + partNo + ' data-quantity=' + quantity + ' data-productName=' + productName + ' " class="undo-saved-for-later">Undo</button></p></div ></div > ');
                toggleDisableRemoveAndAddForLater('disable');
                $(".saved-items-empty").hide();
                $(".saved-items-container").append(data.updatedPartial);
                refreshSaveForLaterView(itemCategory);
                refreshCartCount();
                //let noPartRestrictions = checkPartRestrictions(data.cart);
                var cartRequested = true;
                return addAndRemoveFromCartPostUpdate(e, data, cartRequested).catch(function (data) {
                    subtotalActivateSpinners(false);
                    zeroOrderSummary()
                    toggleDisableRemoveAndAddForLater('enable');
                    enableDisableButton(orderSubmitBtn, site.Utilities.onCheckout() ? orderSubmitBtnText : checkoutBtnText, true);

                })
            }).catch(function (data) {
                console.log("Error transfering part to saved for later.");
                toggleDisableRemoveAndAddForLater('enable');
            });
        })

        $(document).on('click', '.js-saved-to-cart', function (e) {
            e.stopImmediatePropagation();
            toggleDisableRemoveAndAddForLater('disable');
            const isCheckout = site.Utilities.onCheckout();
            var submitBtn = isCheckout ? $("#btn-place-order") : $('.js-checkout-btn');
            enableDisableButton(submitBtn, isCheckout ? loadingSpinner : "Validating Order", true);
            $(this).addClass('disabled');
            $(this).prop('disabled', true);
            let partNo = $(this).data("partno");
            let quantity = $(this).data("quantity");
            let lineItem = $(this).closest('.saved-item');
            let undoItems = $('.js-line-item[data-partno="' + partNo + '"]');
            if (undoItems.length != 0) {
                for (var item of undoItems) {
                    item.remove();
                }
            }
            var query = { PartNo: partNo, Quantity: parseInt(quantity) };
            $.ajax({
                method: "POST",
                url: "/cart/FromSavedToCart",
                dataType: "json",
                data: query
            }).done(function (data) {
                let noPartRestrictions = checkPartRestrictions(data.cart);
                var orderSubmitBtn = $("#btn-place-order").length == 1 ? $("#btn-place-order") : $('.js-checkout-btn');
                lineItem.remove();
                refreshCartCount();
                $('.shopping-cart-empty').hide();

                if ($('.saved-items-container').length == 1) {
                    let savedItemsEmpty = $(".saved-items-empty");
                    //If the user has no saved items, show the message.
                    if (data.cart.savedParts.length == 0) {
                        $(".saved-items-empty").removeClass('d-none');
                        $(".saved-items-empty").show();
                    } else {
                        //Ensure the empty message is hidden, since they have items saved
                        $(".saved-items-empty").addClass('d-none');
                    }
                }

                $("#cart-line-items").append("<div class='js-line-item' data-partno= " + partNo + ">" + data.updatedPartial + "</div>");

                toggleDisableRemoveAndAddForLater('enable');
                if (!noPartRestrictions) {
                    zeroOrderSummary();
                    enableDisableButton(orderSubmitBtn, site.Utilities.onCheckout() ? orderSubmitBtnText : checkoutBtnText, true);
                } else {
                    refreshTotalsWithCartData(data.cart)
                    enableDisableButton(orderSubmitBtn, site.Utilities.onCheckout() ? orderSubmitBtnText : checkoutBtnText, false);
                }

            }).fail(function (data) {
                console.log("Error transfering part to saved for later.");
                toggleDisableRemoveAndAddForLater('enable');
            });
        })
        $(document).on('click', '.js-cart-update-quantity, .js-autoship-frequency', function () {
            this.focus();
        });

        $(document).on('blur', '.js-cart-update-quantity', function (e) {

            var cardHeader = $(this).parents().filter('.js-item-anchor');

            var trigger = e;
            var origin = "";
            
            if (trigger.delegateTarget.activeElement.id === "frequency") {
                origin = "cartFreqUpdate";
            }

            e.stopImmediatePropagation();
            var currentCartQty = $(this).closest(".add-to-cart-wrapper").find('.item-part-number-data').attr("data-incart");
            var inputBoxValue = this.value;
            var orderSubmitBtn = $("#btn-place-order").length == 1 ? $("#btn-place-order") : $('.js-checkout-btn');

            if ((typeof currentCartQty === 'undefined' || inputBoxValue === null) || inputBoxValue == currentCartQty && origin != "cartFreqUpdate") {
                return;
            }

            toggleDisableRemoveAndAddForLater('disable');
            subtotalActivateSpinners(true);
            const isCheckout = site.Utilities.onCheckout();
            var submitBtn = isCheckout ? $("#btn-place-order") : $('.js-checkout-btn');
            enableDisableButton(submitBtn, isCheckout ? loadingSpinner : "Validating Order", true);
            updateQuantity(trigger, origin)
                .catch(error => {
                    console.error("Error updating quantity.", error);
                })
                .then(updateCartReturnData => {
                    site.Cart.checkForEmptyCart(updateCartReturnData);
                    refreshCartCount();
                    var cartRequested = true;

                    return addAndRemoveFromCartPostUpdate(trigger, updateCartReturnData, cartRequested);
                })
                .catch(function (error) {
                    // Erroring here is fine.
                    zeroOrderSummary();
                    subtotalActivateSpinners(false);
                    enableDisableButton(orderSubmitBtn, site.Utilities.onCheckout() ? orderSubmitBtnText : checkoutBtnText, true);
                })
                .finally(() => {
                    subtotalActivateSpinners(false);
                    toggleDisableRemoveAndAddForLater('enable');
                });
        });

        $('.js-cart-update-quantity').keypress(function (e) {
            if (e.which === 13) {
                $(this).blur();
            }
        });

        $(document).on('click', '.undo-remove-item', function (e) {
            e.stopImmediatePropagation();
            $(this).hide();
            const isCheckout = site.Utilities.onCheckout();
            var orderSubmitBtn = $("#btn-place-order").length == 1 ? $("#btn-place-order") : $('.js-checkout-btn');
            enableDisableButton(orderSubmitBtn, isCheckout ? loadingSpinner : "Validating Order", true);
            toggleDisableRemoveAndAddForLater('disable');
            orderSummarySpinnersSpin();
            subtotalActivateSpinners(true);
            let listItemContainer = $(this).closest('.js-line-item');
            let removedItemContainer = $(this).closest('#undo-remove-item');
            let partNo = $(this).data("partno");
            let quantity = $(this).data("quantity");
            if (parseInt(quantity) == 0) {
                quantity = 1;
            }
            removedItemContainer.remove();
            $.when(addToCart(partNo, quantity, "undo", 0, listItemContainer)).then(function (dataAdd) {
                var cartRequested = true;
                refreshCartCount();
                return addAndRemoveFromCartPostUpdate(e, dataAdd, cartRequested).catch (function (data) {
                    zeroOrderSummary()
                    toggleDisableRemoveAndAddForLater('enable');
                    enableDisableButton(orderSubmitBtn, site.Utilities.onCheckout() ? orderSubmitBtnText : checkoutBtnText, true);
                })

            }).catch(function () {
                subtotalActivateSpinners(false);
                enableDisableButton(orderSubmitBtn, isCheckout ? orderSubmitBtnText : checkoutBtnText, true);
                toggleDisableRemoveAndAddForLater('enable');
            });
        });

        $(document).on('click', '.undo-saved-for-later', function (e) {
            e.stopImmediatePropagation();
            var orderSubmitBtn = $("#btn-place-order").length == 1 ? $("#btn-place-order") : $('.js-checkout-btn');
            const isCheckout = site.Utilities.onCheckout();
            toggleDisableRemoveAndAddForLater('disable');
            enableDisableButton(orderSubmitBtn, isCheckout ? loadingSpinner : "Validating Order", true);
            orderSummarySpinnersSpin();
            subtotalActivateSpinners(true);
            let lineItem = $(this).closest('.js-line-item')
            let partNo = $(this).data("partno");
            let quantity = $(this).data("quantity");
            let savedItem = $('.saved-item[data-partno="' + partNo + '"]');

            var query = { PartNo: partNo, Quantity: parseInt(quantity) };
            $.ajax({
                method: "POST",
                url: "/cart/FromSavedToCart",
                dataType: "json",
                data: query
            }).done(function (data) {
                $(lineItem).find('#undo-remove-item').remove();
                $(lineItem).find('.cart-item, .cart-line-messages-container, .compliance').removeClass('d-none');
                $(".shopping-cart-empty").hide();
                savedItem.remove();
                if ($('.saved-item').length === 0) {
                    $(".saved-items-empty").show();
                }
                if (jQuery.active === 0) {
                    refreshCartPartsQuoteCartData(data);
                }
                refreshCartCount();
                var cartRequested = true;
                return addAndRemoveFromCartPostUpdate(e, data, cartRequested).catch(function (data) {
                    zeroOrderSummary()
                    toggleDisableRemoveAndAddForLater('enable');
                    enableDisableButton(orderSubmitBtn, site.Utilities.onCheckout() ? orderSubmitBtnText : checkoutBtnText, true);
                })


            }).fail(function (data) {
                console.log("Error transfering part to saved for later.");
                toggleDisableRemoveAndAddForLater('enable');
                enableDisableButton(submitBtn, isCheckout ? orderSubmitBtnText : checkoutBtnText, true);
            });
        })

        $(document).on('click', '.add-to-saved-for-later', function (e) {
            e.stopImmediatePropagation();
            toggleDisableRemoveAndAddForLater('disable');
            let listItem = $(this).parent().parent().parent().parent();
            listItem.remove();

            let partNo = $(this).data("partno");
            let quantity = $(this).data("quantity");
            const isCheckout = site.Utilities.onCheckout();
            var submitBtn = isCheckout ? $("#btn-place-order") : $('.js-checkout-btn');
            enableDisableButton(submitBtn, isCheckout ? loadingSpinner : "Validating Order", true);
            var query = { PartNo: partNo, Quantity: parseInt(quantity) };
            $.ajax({
                method: "POST",
                url: "/cart/AddToSaved",
                dataType: "json",
                data: query
            }).done(function (data) {
                let emptyCartContainer = $(".shopping-cart-empty");
                if (typeof emptyCartContainer != "undefined") {
                    emptyCartContainer.remove();
                }
                $(".saved-items-container").append(data.updatedPartial);
                //Double check this func below is proper for calling here, should be
                refreshTotalsWithCartData(data.cart);
                refreshCartCount();
                checkPartRestrictions(data.cart);
                toggleDisableRemoveAndAddForLater('enable');
                enableDisableButton(submitBtn, isCheckout ? orderSubmitBtnText : checkoutBtnText, false);
            }).fail(function (data) {
                console.log("Error transfering part to saved for later.");
            });
        })

        $(document).on('click', '.js-disabled', function (e) {
            e.stopImmediatePropagation();
            e.stopImmediatePropagation();
        });

        $(document).on('click', '.continue-to-payment', function (e) {
            e.stopImmediatePropagation();

            // GTM eCommerce Add Shipping Info Event
            const gtmECommerceData = getGTMEcommerceDataFromCart();
            gtmECommerceData["shipping_tier"] = $(".shipping-address-input:checked").attr("data-shipping-method");

            window.dataLayer = window.dataLayer || [];
            dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
            dataLayer.push({
                event: 'add_shipping_info',
                //user_id: quote.customerId,
                ecommerce: gtmECommerceData
            });

            //Hide Shipping Details
            if ($('.shipping-details').is(':visible')) {
                $('.shipping-details').addClass('d-none');
            }
            if (!$('#review-link').hasClass('disabled')) {
                $('#review-link').addClass('disabled');
            }
            if ($('.review-section').is(':visible')) {
                $('.review-section').addClass('d-none');
            }
            if ($('#review-details').is(':visible')) {
                $('#review-details').addClass('d-none');
            }
            if ($('#place-order').is(':visible')) {
                $('#place-order').addClass('d-none');
            }

            //Show payment section
            $('.payment-section').removeClass('d-none');
            $('#payment-link').removeClass('disabled');
            $('#payment-link').removeAttr("style");
            $('#review-link').css('background', 'grey');
            window.history.pushState('', '', '/checkout/payment');
            $(window).scrollTop(0);
        })

        $(document).on('click', '.review-order-section', function (e) {
            e.stopImmediatePropagation();

            var selected = $("input[name='paymentMethod']").filter(':checked');

            if (selected.length == 0) {
                return site.Utilities.displayToast('Payment Method', 'Please select a payment method before continuing.');
            }
            site.Cart.setReviewSection(selected);

            // GTM eCommerce Add Payment Info Event
            const gtmECommerceData = getGTMEcommerceDataFromCart();
            gtmECommerceData["payment_type"] = $(".credit-card-input:checked").attr("data-payment-term");

            window.dataLayer = window.dataLayer || [];
            dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
            dataLayer.push({
                event: 'add_payment_info',
                user_id: cartState.shoppingCartViewModel.customerId,
                ecommerce: gtmECommerceData
            });

            //Hide Payment Section
            if ($('.payment-section').is(':visible')) {
                $('.payment-section').addClass('d-none');
            }
            //Show Review section
            $('.review-section').removeClass('d-none');
            $('#review-details').removeClass('d-none');
            $('#place-order').removeClass('d-none');
            $('#review-link').removeClass('disabled')
            $('#review-link').removeAttr("style");
            window.history.pushState('', '', '/checkout/review');
            $(window).scrollTop(0);
        })

        $(document).on('click', '.back-to-shipping', function (e) {
            e.stopImmediatePropagation();
            $('.shipping-details').removeClass('d-none');
            if ($('.payment-section').is(':visible')) {
                $('.payment-section').addClass('d-none');
            }
            if ($('.review-section').is(':visible')) {
                $('.review-section').addClass('d-none');
            }
            if ($('#review-details').is(':visible')) {
                $('#review-details').addClass('d-none');
            }
            if ($('#place-order').is(':visible')) {
                $('#place-order').addClass('d-none');
            }

            $('#payment-link').addClass('disabled');
            $('#review-link').addClass('disabled');
            $('#payment-link').css('background', 'grey');
            $('#review-link').css('background', 'grey');

            window.history.pushState('', '', '/checkout/shipping');
        })

        $(document).on('click', '#btn-place-order', function (e) {
            e.stopImmediatePropagation();
            var paymentTerm = $('input[name="paymentMethod"]:checked').data().paymentTerm;
            var paymentProfileId = paymentTerm == "CC" ? $('input[name="paymentMethod"]:checked').data().paymentProfileId : null;
            var shipVia = $('input[name="shippingMethod"]:checked').data().shipVia;// "020";
            var poNumber = $('input[name="purchaseOrderNum"]').val();
            //disable order button
            let orderSubmitBtn = $("#btn-place-order");

            //Hide any orderRestrictions that have been set; allow the user to attempt to checkout again in which if their cart is fixed they will be able to proceed.
            //This applies when they have a dollar amount that is exceeding their total allowance, and have removed items from their cart/lowered quantities to where they need to be.
            $('.checkout-payment-alert-msg').hide()
            $('#orderSubmitError').children().remove()
            enableDisableButton(orderSubmitBtn, loadingSpinner, true);
            $.when(submitOrder(paymentTerm, paymentProfileId, shipVia, poNumber)).then(function () {
                enableDisableButton(orderSubmitBtn, orderSubmitBtnText, true);
            }).catch(function () {
                enableDisableButton(orderSubmitBtn, orderSubmitBtnText, true);
            });
        })

        $('#payment-link').css('background', 'grey');
        $('#review-link').css('background', 'grey');

        $(document).on('click', '.use-for-order', function (e) {
            var backToCheckout = false
            if ($('.shipping-address-management').is(':visible') && site.Utilities.stringToBool($('.shipping-address-management').data().ischeckoutreferer)) {
                backToCheckout = true;
                $('#returnToCheckoutLoadingModal').modal("show");
            }
            e.stopImmediatePropagation();
            var addressId = $(this).data().addressId;
            var query = { addressId: addressId };
            $.ajax({
                method: "POST",
                url: "/cart/UseAddressForOrder",
                dataType: "json",
                data: query,
            })
                .done(function (data) {
                    backToCheckout ? location.replace('/checkout/payment') : location.reload();
                })
                .fail(function (data) {
                    console.log(data);
                    console.log('Failure - Updating Order Address Failed');

                });
        });



        var createForm = function (url, data, method) {
            if (method == null) method = 'POST';
            if (data == null) data = {};

            var form = $('<form>').attr({
                method: method,
                action: url
            }).css({
                display: 'none'
            });

            var addData = function (name, data) {
                if ($.isArray(data)) {
                    for (var i = 0; i < data.length; i++) {
                        var value = data[i];
                        addData(name + '[' + i + ']', value);
                    }
                } else if (typeof data === 'object') {
                    for (var key in data) {
                        if (data.hasOwnProperty(key)) {
                            addData(name + '[' + key + ']', data[key]);
                        }
                    }
                } else if (data != null) {
                    form.append($('<input>').attr({
                        type: 'hidden',
                        name: String(name),
                        value: String(data)
                    }));
                }
            };

            for (var key in data) {
                if (data.hasOwnProperty(key)) {
                    addData(key, data[key]);
                }
            }

            return form.appendTo('body');
        }
    }

    /**
     * Retrieves the GTM Ecommerce data from cart.
     * @returns {GTMEcommerceData}
     */
    var getGTMEcommerceDataFromCart = function () {
        const eventData = {
            value: cartState.shoppingCartViewModel.salesPriceSubtotal > 0 ? cartState.shoppingCartViewModel.salesPriceSubtotal : cartState.shoppingCartViewModel.basePriceSubtotal,
            currency: 'USD',
            items: cartState.shoppingCartViewModel.parts.map(function (part, index) {
                let item = {
                    item_id: part.partNo,
                    item_name: part.partDescription,
                    quantity: part.quantityOrdered,
                    price: part.salePrice,
                    discount: part.unitDiscount,
                    index: index
                };

                let brandAttr = part.attributes.filter(x => x.code === "BRAND");
                if (brandAttr !== null && brandAttr !== undefined && brandAttr.length > 0) {
                    item.item_brand = brandAttr[0].value;
                }

                let variantAttr = part.attributes.filter(x => x.code === "CNTNT");
                if (variantAttr !== null && variantAttr !== undefined && variantAttr.length > 0) {
                    item.item_variant = variantAttr[0].value;
                }

                //let categoryAttributes = part.attributes
                //    .filter(
                //        // HI -> Health Interests
                //        x => (x?.code?.startsWith("HI") ?? false)
                //            // BS -> Body Systems
                //            || (x?.code?.startsWith("BS") ?? false)
                //            // DN -> Dietary Needs
                //            || (x?.code?.startsWith("DN") ?? false)
                //    )
                //    .reduce(
                //        (acc, attr) => {
                //            acc.push(...attr.value.split("||").map(x => x.trim()));
                //            return acc;
                //        },
                //        []
                //    );

                ///** @type {string[]} */
                //let categories = [];

                //for (let categoryAttr of categoryAttributes) {
                //    if (!categories.includes(categoryAttr)) {
                //        categories.push(categoryAttr);
                //    }

                //    if (categories.length >= 5) {
                //        break;
                //    }
                //}

                //if (categories.length > 0) {
                //    item.item_category = categories[0];
                //}

                //if (categories.length > 1) {
                //    item.item_category2 = categories[1];
                //}

                //if (categories.length > 2) {
                //    item.item_category3 = categories[2];
                //}

                //if (categories.length > 3) {
                //    item.item_category4 = categories[3];
                //}

                //if (categories.length > 4) {
                //    item.item_category5 = categories[4];
                //}

                return item;
            }),
        };

        return eventData;
    }

    return {
        refreshCartCount: refreshCartCount,
        refreshTotalsWithCartData: refreshTotalsWithCartData,
        refreshCartPartsQuoteCartData: refreshCartPartsQuoteCartData,
        shippingProgressBar: shippingProgressBar,
        refreshSaveForLaterView: refreshSaveForLaterView,
        freeShippingMin: freeShippingMin,
        calculateShippingCost: calculateShippingCost,
        shippingProgressBar: shippingProgressBar,
        checkQuickOrderCartBtn: checkQuickOrderCartBtn,
        bindCartEvents: bindCartEvents,
        quoteOrder: quoteOrder,
        getShippingRates: getShippingRates,
        reselectShippingMethod: reselectShippingMethod,
        enableDisableButton: enableDisableButton,
        setReviewSection: setReviewSection,
        loadingSpinner: loadingSpinner,
        checkForEmptyCart: checkForEmptyCart,
        initializeShoppingCartViewModel: initializeShoppingCartViewModel,
        makeToast: makeToast,
        needShippingData: needShippingData,
        toggleDisableRemoveAndAddForLater: toggleDisableRemoveAndAddForLater,
        setSaveForLater: setSaveForLater,
        orderSummarySpinnersRemove: orderSummarySpinnersRemove,
        orderSummarySpinnersSpin: orderSummarySpinnersSpin,
        setOrderSummaryValuesAfterDataReturns: setOrderSummaryValuesAfterDataReturns,
        checkoutBtnText: checkoutBtnText,
        orderSubmitBtnText: orderSubmitBtnText
    }

}());

$(document).ready(function () {
    site.Cart.requestShippingRates = false;
    site.Cart.bindCartEvents();
    //Removing as this is called on load of the _ShippingSection.cshtml and this makes it get called twice.
    //site.Cart.shippingProgressBar();
    site.Cart.setSaveForLater();
    var selected = $("input[name='paymentMethod']").filter(':checked');

    if (selected.hasClass('sweet-potatoe')) {
        $('#review-link').addClass('disabled');
    }
})